
import startApp from "../../entry";
import aboutPage from "./about.vue";

startApp(aboutPage);
